import {
	CoverageMode,
	DanteNetworkAccess,
	DeviceAuthentication,
	DeviceCompatibilityLevel,
	DeviceConferenceOperationMode,
	DeviceLicense,
	DeviceLicenseWarningDetails,
	DeviceModel,
	DeviceStatus,
	EthernetPowerSourceType,
	Firmware,
	MissingFeatureType
} from '@shure/shared/angular/data-access/system-api/models';

import { IntellimixChannel } from './intellimix-channel';

export enum ChannelAutomixMode {
	Custom = 'CUSTOM',
	Manual = 'MANUAL',
	Gating = 'GATING',
	GainSharing = 'GAIN_SHARING',
	Classic = 'CLASSIC',
	Smooth = 'SMOOTH'
}

export interface IntellimixDevice {
	id: string;
	model: DeviceModel;
	compatibility: DeviceCompatibilityLevel;
	status: DeviceStatus;
	isDevicePreviewSupported: boolean;
	features: {
		coverageMode?: {
			coverageMode: CoverageMode;
		} & MissingFeatureType;
		virtualAcousticBoundary?: {
			enabled: boolean;
			sensitivity: number;
		} & MissingFeatureType;
		virtual?: {
			virtual: boolean;
		} & MissingFeatureType;
		automixGainMetering?: {
			enabled: boolean;
		} & MissingFeatureType;
		echoReductionActive?: {
			enabled: boolean;
		} & MissingFeatureType;
		echoReductionMode?: {
			mode: string;
		} & MissingFeatureType;
		gateInhibitEnabled?: {
			enabled: boolean;
		} & MissingFeatureType;
		allIntellimixBypass?: {
			bypassed: boolean;
		} & MissingFeatureType;
		allEqualizersBypass?: {
			bypassed: boolean;
		} & MissingFeatureType;
		channels?: { channels: IntellimixChannel[] } & MissingFeatureType;
		authentication?: DeviceAuthentication & MissingFeatureType;
		danteNetworkAccess?: DanteNetworkAccess & MissingFeatureType;
		firmware?: Firmware & MissingFeatureType;
		license?: DeviceLicense<DeviceLicenseWarningDetails> & MissingFeatureType;
		loudspeaker?: {
			available: boolean;
			enabled: boolean;
		} & MissingFeatureType;
		ethernetPowerSource?: {
			type: EthernetPowerSourceType;
		} & MissingFeatureType;
		conferencingOperationMode?: {
			mode: DeviceConferenceOperationMode;
		} & MissingFeatureType;
		dectRfSpectrumScan?: {
			inProgress: boolean;
		} & MissingFeatureType;
	};
	constraints: {
		virtualAcousticBoundary: {
			sensitivity: {
				range: {
					min: number;
					max: number;
					step: number;
				};
			};
		};
		conferencingOperationMode?: {
			options: DeviceConferenceOperationMode[];
		};
	};
}
